module.exports = __webpack_public_path__ + "res/review.e2e4f9672710da3d76612af90233b5ca.webp";